var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_887_2605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 20.764H5C3.6744 20.7625 2.40356 20.2352 1.46622 19.2978C0.528882 18.3605 0.00158786 17.0896 0 15.764L0 5.76404C0.00158786 4.43844 0.528882 3.1676 1.46622 2.23026C2.40356 1.29292 3.6744 0.765626 5 0.764038L15 0.764038C16.3256 0.765626 17.5964 1.29292 18.5338 2.23026C19.4711 3.1676 19.9984 4.43844 20 5.76404V15.764C19.9984 17.0896 19.4711 18.3605 18.5338 19.2978C17.5964 20.2352 16.3256 20.7625 15 20.764ZM24 19.764V6.76404C24 6.49882 23.8946 6.24447 23.7071 6.05693C23.5196 5.8694 23.2652 5.76404 23 5.76404C22.7348 5.76404 22.4804 5.8694 22.2929 6.05693C22.1054 6.24447 22 6.49882 22 6.76404V19.764C22 20.5597 21.6839 21.3227 21.1213 21.8854C20.5587 22.448 19.7956 22.764 19 22.764H6C5.73478 22.764 5.48043 22.8694 5.29289 23.0569C5.10536 23.2445 5 23.4988 5 23.764C5 24.0293 5.10536 24.2836 5.29289 24.4711C5.48043 24.6587 5.73478 24.764 6 24.764H19C20.3256 24.7625 21.5964 24.2352 22.5338 23.2978C23.4711 22.3605 23.9984 21.0896 24 19.764Z",
    fill: "#CB2129"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_887_2605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.764038)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.3303635a8589cdfe6480c581798c80b7.svg";
export { ForwardRef as ReactComponent };